import React, { useContext } from 'react';
import { Heart } from 'lucide-react';
import { FavoritesContext } from '../FavoritesContext';
import './FavoriteButton.css';
import { useLanguage } from '../contexts/LanguageContext';

const FavoriteButton = ({ productId, className = '', label = false }) => {
  const { isFavorite, isUpdating, toggleFavorite } = useContext(FavoritesContext);
  const { t } = useLanguage();
  const active = isFavorite(productId);
  const updating = isUpdating(productId);

  return (
    <button
      type="button"
      className={`favorite-button ${active ? 'favorite-button--active' : ''} ${className}`.trim()}
      aria-label={t(active ? 'Remove product from favorites' : 'Add product to favorites')}
      aria-pressed={active}
      aria-busy={updating}
      disabled={updating}
      title={t(active ? 'Remove from favorites' : 'Add to favorites')}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        void toggleFavorite(productId);
      }}
    >
      <Heart size={19} fill={active ? 'currentColor' : 'none'} />
      {label && <span>{t(updating ? 'Saving…' : active ? 'Saved' : 'Favorite')}</span>}
    </button>
  );
};

export default FavoriteButton;
